module.exports = __webpack_public_path__ + "static/media/accessories.9f4310b2.jpg";